import { Box, Spacer, Text } from '@jfs/ui-new'
import { Icon } from '@jfs/ui-new/src/comps/IconNew'
import { FC, useEffect, useRef, useState } from 'react'
import { Switch } from 'react-native'
import { DropdownOptimised } from '../../../comps/DropdownNew'
import { DropdownTypes as types } from '../../../comps/DropdownNew/types'
import { useStores } from '../../../data/store'
import styles from '../styles'

const segmentedByData = [
  {
    id: '1',
    value: 'Payment Method',
  },
  {
    id: '2',
    value: 'Card Networks',
  },
  {
    id: '3',
    value: 'Bank',
  },
  {
    id: '4',
    value: 'Status',
  },
  {
    id: '5',
    value: 'Platform',
  },
  {
    id: '6',
    value: 'Wallet',
  },
]

export const segmentedVsDropdownData: any = {
  'Payment Method': [
    {
      id: '1',
      value: 'Card Networks',
    },
    {
      id: '2',
      value: 'Bank',
    },
    {
      id: '3',
      value: 'Status',
    },
    {
      id: '4',
      value: 'Platform',
    },
    {
      id: '5',
      value: 'Wallet',
    },
  ],
  'Card Networks': [
    {
      id: '1',
      value: 'Payment Method',
    },
    {
      id: '2',
      value: 'Status',
    },
    {
      id: '3',
      value: 'Platform',
    },
  ],
  Bank: [
    {
      id: '1',
      value: 'Payment Method',
    },
    {
      id: '2',
      value: 'Platform',
    },
    {
      id: '3',
      value: 'Status',
    },
  ],
  Status: [
    {
      id: '1',
      value: 'Payment Method',
    },
    {
      id: '2',
      value: 'Card Networks',
    },
    {
      id: '3',
      value: 'Bank',
    },
    {
      id: '4',
      value: 'Platform',
    },
    {
      id: '5',
      value: 'Wallet',
    },
  ],
  Platform: [
    {
      id: '1',
      value: 'Payment Method',
    },
    {
      id: '2',
      value: 'Card Networks',
    },
    {
      id: '3',
      value: 'Bank',
    },
    {
      id: '4',
      value: 'Status',
    },
    {
      id: '5',
      value: 'Wallet',
    },
  ],
  Wallet: [
    {
      id: '1',
      value: 'Payment Method',
    },
    {
      id: '2',
      value: 'Status',
    },
    {
      id: '3',
      value: 'Platform',
    },
  ],
}

const timeData = [
  {
    id: '1',
    value: 'Hourly',
  },
  {
    id: '2',
    value: 'Daily',
  },
  {
    id: '3',
    value: 'Monthly',
  },
]
const GraphHeader: FC = ({ tittle }: any) => {
  const {
    updateSegmentedBy,
    updateSegmentedVs,
    updateDurationType,
    updateTransactionType,
    getGraphPrefrences,
    triggerRefreshApi,
    fromDate,
    toDate,
  } = useStores((root) => ({
    updateSegmentedBy: root.insights.updateSegmentedBy,
    updateSegmentedVs: root.insights.updateSegmentedVs,
    updateDurationType: root.insights.updateDurationType,
    getGraphPrefrences: root.insights.getGraphPrefrences,
    updateTransactionType: root.insights.updateTransactionType,
    triggerRefreshApi: root.insights.triggerRefreshApi,
    fromDate: root.insights.graphPrefrences.selectedDate.fromDate,
    toDate: root.insights.graphPrefrences.selectedDate.toDate,
  }))
  const graphPrefrences = getGraphPrefrences()

  const [ddData, setDdData] = useState(timeData)
  const firstUpdate = useRef(true)

  useEffect(() => {
    const selectedDuration = toDate - fromDate
    const today = 24 * 60 * 60 * 1000
    const sevendays = 7 * 24 * 60 * 60 * 1000
    const thirtyDays = 30 * 24 * 60 * 60 * 1000
    const ninetyDays = 90 * 24 * 60 * 60 * 1000
    const getIdMapped = (data: any) => {
      const retData: any = []
      data.map((item: any, index: number) => {
        const a = {
          ...item,
          id: `${index + 1}`,
        }
        retData.push(a)
      })
      return retData
    }
    let durationType: string = ''
    if (selectedDuration <= today) {
      const data = timeData.slice(0, 1)
      durationType = 'Hourly'
      setDdData(getIdMapped(data))
    } else if (selectedDuration <= sevendays) {
      const data = timeData.slice(0, 2)
      durationType = 'Daily'
      setDdData(getIdMapped(data))
    } else if (selectedDuration > sevendays && selectedDuration <= thirtyDays) {
      const data = timeData.slice(1, 2)
      durationType = 'Daily'
      setDdData(getIdMapped(data))
    } else if (selectedDuration > thirtyDays && selectedDuration <= ninetyDays) {
      const data = timeData.slice(1, 3)
      durationType = 'Monthly'
      setDdData(getIdMapped(data))
    } else {
      const data = timeData.slice(1, 3)
      durationType = 'Monthly'
      setDdData(getIdMapped(data))
    }
    if (firstUpdate.current) {
      firstUpdate.current = false
      durationType = graphPrefrences.durationType ?? 'Hourly'
    }
    updateDurationType(durationType)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fromDate, toDate])

  const getSegmentVsData = () => {
    return segmentedVsDropdownData[graphPrefrences.segmentedBy]
  }
  return (
    <Box {...styles.graphView.tittleContainer} justifyContent="space-between" flexWrap="wrap" margin={20}>
      <Box flexDirection="row" alignItems="center" flexWrap="wrap" maxWidth="100%" paddingVertical={4}>
        <Text {...styles.graphView.tittle}>{tittle}</Text>
        <Spacer direction="horizontal" size={8} />
        <Text {...styles.graphView.tittle} color={graphPrefrences.transactions === 'Value' ? 'BLUE' : 'PRIMARY_GREY'}>
          Value
        </Text>
        <Switch
          style={{ transform: [{ scaleX: 0.6 }, { scaleY: 0.6 }] }}
          trackColor={{ false: '#1386B080', true: '#1386B080' }}
          thumbColor={'#1386B0'}
          onValueChange={() => updateTransactionType(graphPrefrences.transactions === 'Count' ? 'Value' : 'Count')}
          value={graphPrefrences.transactions === 'Count'}
        />

        <Text
          {...styles.graphView.tittle}
          color={graphPrefrences.transactions === 'Count' ? 'PRIMARY' : 'PRIMARY_GREY'}>
          Count
        </Text>
        <Spacer direction="horizontal" size={16} />
        <Text {...styles.graphView.tittle}>Segmented by</Text>
        <Spacer direction="horizontal" size={8} />
        <DropdownOptimised
          // borderColor={graphPrefrences.segmentedVs.length > 0 ? 'BLUE' : 'DISABLED_GREY'}
          placeHolder={graphPrefrences.segmentedBy}
          onChange={(val: any) => {
            if (val !== graphPrefrences.segmentedBy) {
              updateSegmentedBy(val)
              //making segmented vs empty on segmented vs change
              updateSegmentedVs('')
            }
          }}
          data={segmentedByData}
          type={types.DEFAULT_WITH_IMAGE}
          testID={'segmentedByList'}
        />
        <Spacer direction="horizontal" size={8} />
        <Text {...styles.graphView.tittle} color={graphPrefrences.segmentedVs.length > 0 ? 'BLUE' : 'PRIMARY_GREY'}>
          Vs
        </Text>
        <Spacer direction="horizontal" size={8} />
        <DropdownOptimised
          onChange={(val: any) => {
            updateSegmentedVs(val)
          }}
          data={getSegmentVsData()}
          placeHolder={graphPrefrences?.segmentedVs}
          type={types.SELECTABLE_HIGHLIGHT}
          title={'Select Segment'}
          testID={'segmentSelectionList'}
        />
      </Box>
      <Box flexDirection="row" flexWrap="wrap" paddingVertical={4}>
        {graphPrefrences?.segmentedVs.length === 0 && (
          <DropdownOptimised
            placeHolder={graphPrefrences.durationType}
            onChange={(val: any) => {
              updateDurationType(val)
            }}
            data={ddData}
            type={types.DEFAULT_WITH_IMAGE}
          />
        )}
        <Box
          marginHorizontal={20}
          paddingHorizontal={8}
          borderRadius={4}
          borderWidth={1}
          testID="triggerGraph"
          onPress={() => {
            triggerRefreshApi()
          }}
          borderColor="BORDER_COLOR"
          justifyContent="center">
          <Icon id="ICON_REFRESH_CIRCLE" size={16} color="DARK_GREY" />
        </Box>
      </Box>
    </Box>
  )
}

export { GraphHeader }
